export const editorToolbarModules = ['bold', 'italic', 'link']
